import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Hook to set the document title based on the current route
 * @param defaultTitle Default title to use if no specific title is found
 */
export const useDocumentTitle = (defaultTitle = 'Socialness.ai') => {
  const location = useLocation();
  const { t } = useTranslation();
  
  useEffect(() => {
    const path = location.pathname;
    let title = defaultTitle;
    
    // Map routes to titles
    if (path.startsWith('/analytics')) {
      title = `${t('analytics.title')} | Socialness.ai`;
    } else if (path.startsWith('/brands/new')) {
      title = `${t('brands.create')} | Socialness.ai`;
    } else if (path.startsWith('/brands') && path.includes('/edit')) {
      title = `${t('brands.edit')} | Socialness.ai`;
    } else if (path.startsWith('/brands')) {
      title = `${t('brands.title')} | Socialness.ai`;
    } else if (path.startsWith('/social-media-hub')) {
      title = `${t('accounts.title')} | Socialness.ai`;
    } else if (path.startsWith('/team')) {
      title = `${t('teamMembers.title')} | Socialness.ai`;
    } else if (path.startsWith('/billing')) {
      title = `${t('billing.title')} | Socialness.ai`;
    } else if (path.startsWith('/settings')) {
      title = `${t('settings.title')} | Socialness.ai`;
    } else if (path.startsWith('/ai-personas-builder')) {
      title = `${t('personas.title')} - Socialness.ai`;
    } else if (path.startsWith('/calendar')) {
      title = `${t('calendar.title')} | Socialness.ai`;
    } else if (path.startsWith('/auth/login')) {
      title = `${t('auth.login.title')} | Socialness.ai`;
    } else if (path.startsWith('/auth/signup')) {
      title = `${t('auth.signup.title')} | Socialness.ai`;
    }
    
    // Set the document title
    document.title = title;
    
    // Clean up function
    return () => {
      document.title = defaultTitle;
    };
  }, [location.pathname, t, defaultTitle]);
}; 